import { render, staticRenderFns } from "./xeroImportContactDialog.vue?vue&type=template&id=1180685d&"
import script from "./xeroImportContactDialog.vue?vue&type=script&lang=js&"
export * from "./xeroImportContactDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports